import PropTypes from 'prop-types'

import CustomCheckBox from 'components/CustomCheckBox'
import InputRangeSlider from 'components/InputRangeSlider'
import useJackpotPledges from 'hooks/useJackpotPledges'
import { COLOURS, STRING } from 'resources'
import formatPoints, { convertAmountToPoints } from 'utils/format-points'

import {
  Form,
  SectionContainer,
  SectionText,
  SectionBoldText,
  DeleteButton,
  PledgeButton,
  SuccessIcon,
  ErrorMessage,
  CompletedRequestContainer,
} from './styles'

const JackpotAmountSelector = ({ currentPledge, numPrizes, fetchData }) => {
  const {
    minPoints,
    maxUserPoints,
    selectedAmount,
    isInvalid,
    isUpdatedPledge,
    hasPledge,
    isUpdatingPledge,
    isDeletingPledge,
    autoPledgeEnabled,
    showRequestComplete,
    pledgeErrorMessage,
    handleRequestAmountChange,
    toggleAutoPledge,
    onRequestPledge,
    onDeletePledge,
  } = useJackpotPledges({ currentPledge, fetchData })

  return (
    <>
      <SectionContainer>
        <SectionBoldText>{STRING.jackpot.instructions.title}</SectionBoldText>
        <SectionText>{STRING.jackpot.instructions.step1}</SectionText>
        <SectionText>{STRING.jackpot.instructions.step2}</SectionText>
        <SectionText>{STRING.jackpot.instructions.step3(numPrizes)}</SectionText>
      </SectionContainer>
      <Form
        onSubmit={(e) => {
          e.preventDefault()
          onRequestPledge()
        }}
      >
        <SectionContainer>
          <SectionBoldText>{STRING.jackpot.setYourPoints}</SectionBoldText>
        </SectionContainer>
        <SectionBoldText>{formatPoints(selectedAmount.toString(), false, true, false)}</SectionBoldText>
        <InputRangeSlider
          type="range"
          min={minPoints}
          max={maxUserPoints}
          step={1}
          size="2"
          onChange={(event) => handleRequestAmountChange(event.target.value)}
          value={convertAmountToPoints(selectedAmount)}
          disabled={isUpdatingPledge || isDeletingPledge}
        />
        <CustomCheckBox
          isChecked={autoPledgeEnabled}
          label={STRING.jackpot.autoPledge}
          editable={!isUpdatingPledge && !isDeletingPledge}
          setChecked={toggleAutoPledge}
          borderColour={COLOURS.neutralBlack}
          checkColour={COLOURS.darkPurple}
        />
        {showRequestComplete && (
          <CompletedRequestContainer>
            <SuccessIcon />
            <SectionText>
              {hasPledge ? STRING.jackpot.requestComplete('created!') : STRING.jackpot.requestComplete('cancelled.')}
            </SectionText>
          </CompletedRequestContainer>
        )}
        <PledgeButton
          onPress={onRequestPledge}
          disabled={isInvalid || !isUpdatedPledge || isDeletingPledge}
          isLoading={isUpdatingPledge}
          type="submit"
        >
          {STRING.jackpot.enterNow}
        </PledgeButton>
        <DeleteButton onPress={onDeletePledge} disabled={!hasPledge || isUpdatingPledge} isLoading={isDeletingPledge}>
          {STRING.jackpot.cancelEntry}
        </DeleteButton>
      </Form>
      {!!pledgeErrorMessage && <ErrorMessage>{pledgeErrorMessage}</ErrorMessage>}
    </>
  )
}

JackpotAmountSelector.propTypes = {
  currentPledge: PropTypes.string.isRequired,
  numPrizes: PropTypes.number.isRequired,
  fetchData: PropTypes.func.isRequired,
}

export default JackpotAmountSelector
